import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import Select from '@jetbrains/ring-ui/components/select/select'
import {useMemo} from 'react'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {emptyArray} from '../../../../../utils/empty'
import styles from '../../Header.css'

export default function NodeSwitcher() {
  const serverNodes = useAppSelector(state => state.nodeInfo?.serverNodes ?? emptyArray)
  const currentNode = useAppSelector(state => state.nodeInfo?.currentNode ?? '')
  const data = useMemo(
    () =>
      serverNodes.map(node => {
        const url = new URL(location.href)
        url.searchParams.set('__nodeId', node)
        return {key: node, label: node, href: url.href}
      }),
    [serverNodes],
  )

  return (
    <>
      {'Current node: '}
      <Select
        type={Select.Type.INLINE}
        selected={{key: currentNode, label: currentNode, href: ''}}
        data={data}
        directions={[Directions.BOTTOM_RIGHT, Directions.TOP_RIGHT]}
        popupClassName={styles.popup}
      />
    </>
  )
}
